import { useNavigate, useParams } from 'react-router-dom'

import { MyTrainingsSurveysAnswersIndexDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { FormRender } from 'modules/forms'
import { FormResponsesSidepanel } from 'modules/forms/components/FormResponses/FormRenderResponses/FormResponsesSidepanel'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const Answer = () => {
  const { materialized_form_id, membership_id } = useParams<{
    materialized_form_id: string
    membership_id: string
  }>()
  const {
    data,
    loading: loadingAnswers,
    error,
  } = useQuery(MyTrainingsSurveysAnswersIndexDocument, {
    variables: {
      membershipId: membership_id,
      materializedFormId: materialized_form_id ?? '',
    },
  })
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const formId = data?.forms.materializedForm?.form?.id ?? ''
  const formType = data?.forms.materializedForm?.form?.formType
  const hasPreviousAnswers = (data?.forms.answersConnection?.nodes?.length ?? 0) > 0
  const onClose = () => {
    navigate(navigation.myTrainings.surveys.fullPath())
  }
  const onSubmitSuccess = () => {
    if (formType === 'knowledge') {
      navigate(
        navigation.myTrainings.surveys.score.fullPath({
          membership_id: String(membership_id),
          materialized_form_id: String(materialized_form_id),
        })
      )
    } else {
      navigate(navigation.myTrainings.surveys.fullPath())
    }
  }
  return (
    <ResponsivePage.NestedBody loading={loadingAnswers} error={error}>
      {formId && !hasPreviousAnswers && (
        <FormRender
          mode="answer"
          isOpen
          onClose={onClose}
          onSubmitSuccess={onSubmitSuccess}
          formId={formId}
          membershipId={membership_id ?? ''}
          resourceType="Trainings::Training"
          resourceHeaderModule={{
            href: navigation.myTrainings.surveys.fullPath(),
            id: 'my_trainings',
            label: i18n.t('trainings.my_training.surveys'),
          }}
        />
      )}
      {formId && hasPreviousAnswers && (
        <FormResponsesSidepanel
          formId={formId}
          membershipId={membership_id ?? ''}
          resourceType="Trainings::Training"
          materializedFormResourceType="Trainings::TrainingClass"
          isOpen
          onClose={onClose}
          resourceHeaderModule={{
            href: navigation.myTrainings.surveys.fullPath(),
            id: 'my_trainings',
            label: i18n.t('trainings.my_training.surveys'),
          }}
        />
      )}
    </ResponsivePage.NestedBody>
  )
}

export default Answer
